import { Message } from "primereact/message";
import { Fragment } from "react";

import styles from "./cartao-alteracao.module.scss";
import type { CartaoAlteracaoViewModel, CampoCartaoLinha } from "./types-cartao-alteracao";

function ValorCampo({ campo }: { campo: CampoCartaoLinha }) {
  if (!campo.anterior) return <>{campo.valor}</>;
  return (
    <>
      <s className={styles.anterior}>{campo.anterior}</s>
      <i className={`pi pi-arrow-right ${styles.seta}`} aria-hidden />
      <mark className={styles.destaque}>{campo.valor}</mark>
    </>
  );
}

export function CartaoAlteracaoView({
  recurso,
  removido,
  titulo,
  categoria,
  tagConflito,
  campos,
  aviso,
  falha,
  mensagem,
  ajustePendente,
  jaJustificado,
  children,
}: CartaoAlteracaoViewModel) {
  return (
    <Fragment>
      {aviso ? (
        <Message
          severity="warn"
          role="status"
          text={aviso}
          className={styles.alertaRevalidacao}
          data-testid="cartao-revalidacao"
        />
      ) : null}
      {removido ? (
        <div className={styles.vinculo} data-testid="cartao-vinculo">
          <span className={styles.chip}>
            <i className="pi pi-sort-alt" aria-hidden />
            {removido.vinculo}
          </span>
        </div>
      ) : null}
      <div
        className={`${styles.cartao} ${falha ? styles.cartaoFalha : ""}`}
        data-testid={removido ? "cartao-removido" : "cartao-alteracao"}
      >
        <div className={styles.cabecalho}>
          <span className={styles.nome}>
            {removido ? <s className={styles.anterior}>{recurso}</s> : recurso}
          </span>
          <span className={styles.tagTipo}>{categoria}</span>
          {removido ? <span className={styles.tagRemovido}>{titulo}</span> : null}
          {tagConflito ? (
            <span className={styles.tagConflito} data-testid="cartao-tag-conflito">
              <i className="pi pi-exclamation-triangle" aria-hidden />
              {tagConflito}
            </span>
          ) : null}
          {children ? <span className={styles.acoes}>{children}</span> : null}
        </div>
        <dl className={styles.campos}>
          {campos.map((campo) => (
            <div key={campo.rotulo} className={styles.linha}>
              <dt>{campo.rotulo}</dt>
              <dd>
                <ValorCampo campo={campo} />
              </dd>
            </div>
          ))}
        </dl>
        {mensagem ? (
          <p
            className={falha ? styles.mensagemFalha : styles.aviso}
            data-testid="aplicar-item-mensagem"
          >
            {falha ? <i className="pi pi-exclamation-triangle" aria-hidden /> : null}
            {mensagem}
          </p>
        ) : null}
        {removido ? <p className={styles.orientacao}>{removido.aviso}</p> : null}
        {jaJustificado ? (
          <p className={styles.aviso} data-testid="cartao-ja-justificado">
            {jaJustificado}
          </p>
        ) : null}
        {ajustePendente ? (
          <p className={styles.aviso} data-testid="cartao-ajuste-pendente">
            Ajuste pendente: {ajustePendente}
          </p>
        ) : null}
      </div>
    </Fragment>
  );
}
